import { render, staticRenderFns } from "./exspansion_docs.vue?vue&type=template&id=27067e62&scoped=true&"
import script from "./exspansion_docs.vue?vue&type=script&lang=js&"
export * from "./exspansion_docs.vue?vue&type=script&lang=js&"
import style0 from "./exspansion_docs.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./exspansion_docs.vue?vue&type=style&index=1&id=27067e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27067e62",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27067e62')) {
      api.createRecord('27067e62', component.options)
    } else {
      api.reload('27067e62', component.options)
    }
    module.hot.accept("./exspansion_docs.vue?vue&type=template&id=27067e62&scoped=true&", function () {
      api.rerender('27067e62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/exspansion_docs.vue"
export default component.exports